import classes from "./Aboutus.module.css";
import tvunit from "../assets/specialisation/tvunit.jpg";
import kitchen from "../assets/specialisation/kitchen.jpg";
import upholstery from "../assets/specialisation/upholstery.jpg";
import indoor from "../assets/specialisation/indoor.jpg";


function Aboutus() {
  return (
    <div className={classes.pageWrapper}>
      <div className={classes.pageHeader}>
        <header>About Us</header>
      </div>

      <div className={classes.intro}>
        <p>
          First Number Furniture have forged an enviable reputation in Interior and Exterior
          Contracting, transforming creative concepts into the highest quality contracts.
          A powerful legacy of this experience is the close working relationship we like to form
          with every client's design team. Initiating grounds in design conceptualisation and a
          keen eye for detail — from manufacturing through to installations. Today First Number
          Furniture's expertise extends to a range of sectors including high-end Residential and
          Commercial fit-out works all over the United Arab Emirates. In all cases First Number
          Furniture prides itself on hands-on project management and strict cost control.
          We would be happy to provide references for our work.
        </p>
      </div>

      <h2 className={classes.specialisationTitle}>Our Specialisation</h2>

      <div className={classes.specialisationGrid}>
        <div className={classes.box} style={{ backgroundImage: `url(${kitchen})` }}>
          <p>Kitchen Units</p>
        </div>
        <div className={classes.box} style={{ backgroundImage: `url(${tvunit})` }}>
          <p>TV Units</p>
        </div>
        <div className={classes.box} style={{ backgroundImage: `url(${upholstery})` }}>
          <p>Upholstery</p>
        </div>
        <div className={classes.box} style={{ backgroundImage: `url(${indoor})` }}>
          <p>Indoor</p>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;
